import { AuthAxiosInterceptor } from "api/core/consts";

export const sign = {
  join: (body) => AuthAxiosInterceptor.post('/register', body),
  login: (body) => AuthAxiosInterceptor.post('/login', body),
  findUserLoginId: (body) => AuthAxiosInterceptor.post('/findUserLoginId', body),
  findUserPassword: (body) => AuthAxiosInterceptor.post('/findUserPassword', body),
};
